// What the browser may know about the Lineup's words (sprint 31 item 1): the fourteen questions and the one visible-cue rule.
// The answers (the bank and the pools in game/lineup-bank.js and game/lineup-pool.js) stay on the server; a question is shown to the
// player anyway, and the cue rule is the same by-eye rule the AIs vote by. Pure, browser-safe, ASCII only.
export const QUESTIONS = [
  'What did you eat last?', 'What is in your pocket?', 'Describe your morning in five words.', 'What is the worst smell you know?',
  'What do you do when you cannot sleep?', 'Name something you lost.', 'Give a dog a name.', 'What are you afraid of?',
  'What song is stuck in your head?', 'What would you do with a free hour?', 'What can you hear right now?', 'Tell me a small lie.',
  'What is your favourite colour, and why?', 'What is the last thing you bought?',
];

// How "like a person typed it" a card looks, 0 to 4, from the text alone: a lowercase start, no closing . ! ? or ), a digit, a casual word
// or a bracket or "...". It is the SAME rule the AIs use to size each other up when they vote, and a bot "evidence locker" uses to read the
// table. A person can do the same by eye. It is deliberately weak: see the bank's decoys.
const CASUAL = /\b(lol|idk|tbh|ugh|honestly|kinda|gonna|ya|nah|yeah|ok|okay|hmm|um|haha|oops|rip|help|obviously|whatever)\b|\.\.\.|\(/i;
export function cueScore(text) {
  const t = String(text ?? '').trim();
  return (/^[a-z]/.test(t) ? 1 : 0) + (/[.!?)]$/.test(t) ? 0 : 1) + (/\d/.test(t) ? 1 : 0) + (CASUAL.test(t) ? 1 : 0);
}
